import styled from "styled-components";
import { Button } from "../components/Button/Button";
import { useState } from "react";
import { ApiRequest } from "../api/Api";
import { useMessageStore } from "../store/MessageStore";

export const Transfer = () => {
	const addMessage = useMessageStore((state) => state.addMessage);
	const [isMain, setIsMain] = useState(false);
	const [from, setFrom] = useState("");
	const [to, setTo] = useState("");
	const [amount, setAmount] = useState<number>();
	const [token, setToken] = useState<number>();
	const [type, setType] = useState("");
	const [txid, setTxid] = useState("");

	const onTransactionHandler = async () => {
		if (!type || type === "") {
			addMessage("error", "network_type_undefined");
			return;
		}
		if (!amount || amount <= 0) {
			addMessage("error", "amount_undefined");
			return;
		}

		if (!to || !txid || to === "" || txid === "" || !from || from === "") {
			addMessage("error", "transaction_data_undefined");
			return;
		}

		const apiResponse = await ApiRequest("/transfer/transaction", {
			from,
			to,
			amount: amount || 0,
			txid,
			type,
		});

		if (apiResponse?.status === "success") {
			// setTo("");
			// setAmount(undefined);
			// setTxid("");
			// setType("");
		}
	};

	const onTransferHandler = async () => {
		if (!type || type === "") {
			addMessage("error", "network_type_undefined");
			return;
		}
		if (!amount || amount <= 0) {
			addMessage("error", "amount_undefined");
			return;
		}
		if ((!isMain && (from === "" || to === "")) || (isMain && to === "")) {
			addMessage("error", "recepient_undefined");
			return;
		}

		if (
			(!isMain &&
				(type === "eth" || type === "erc20") &&
				(from.substring(0, 2) !== "0x" ||
					to.substring(0, 2) !== "0x")) ||
			((type === "trx" || type === "trc20") &&
				(from.substring(0, 2) === "0x" || to.substring(0, 2) === "0x"))
		) {
			addMessage("error", "wrong_wallet_type");
			return;
		}

		const apiResponse = await ApiRequest("/transfer", {
			isMain,
			from,
			to,
			amount: amount || 0,
			type,
		});

		if (apiResponse?.status === "success") {
			// setIsMain(false);
			// setFrom("");
			// setTo("");
			// setAmount(undefined);
			// setToken(undefined);
			// setType("");
		}
	};

	return (
		<StyledComponent>
			<div className="title">Перевод средств между кошельками</div>
			<div className="body">
				<label htmlFor="isMain">Main wallet</label>
				<input
					type="checkbox"
					id="isMain"
					onChange={() => setIsMain(!isMain)}
				/>
				{!isMain ? (
					<input
						type="text"
						placeholder="From address"
						value={from}
						onChange={(e) => setFrom(e.target.value)}
					/>
				) : null}
				<input
					type="text"
					placeholder="To address"
					value={to}
					onChange={(e) => setTo(e.target.value)}
				/>
				<input
					type="number"
					placeholder="Amount"
					value={amount}
					onChange={(e) => setAmount(+e.target.value)}
				/>
				<input
					type="number"
					placeholder="2FA"
					value={token}
					onChange={(e) => setToken(+e.target.value)}
				/>
				<select value={type} onChange={(e) => setType(e.target.value)}>
					<option value="">Coin type</option>
					<option value="trc20">Usdt (Trc20)</option>
					<option value="trx">TRX</option>
					<option value="erc20">Usdt (Erc20)</option>
					<option value="eth">ETH</option>
				</select>
				<Button onClick={onTransferHandler}>Send</Button>
			</div>
			<div className="title">Добавление транзакции вручную</div>
			<div className="body">
				<input
					type="text"
					placeholder="From address"
					value={from}
					onChange={(e) => setFrom(e.target.value)}
				/>
				<input
					type="text"
					placeholder="To address"
					value={to}
					onChange={(e) => setTo(e.target.value)}
				/>
				<input
					type="number"
					placeholder="Amount"
					value={amount}
					onChange={(e) => setAmount(+e.target.value)}
				/>
				<input
					type="text"
					placeholder="Transaction ID"
					value={txid}
					onChange={(e) => setTxid(e.target.value)}
				/>
				<select value={type} onChange={(e) => setType(e.target.value)}>
					<option value="">Coin type</option>
					<option value="trc20">Usdt (Trc20)</option>
					<option value="trx">TRX</option>
					<option value="erc20">Usdt (Erc20)</option>
					<option value="eth">ETH</option>
				</select>
				<Button onClick={onTransactionHandler}>Send</Button>
			</div>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;
	text-align: center;

	& .title {
		font-size: 2rem;
	}
	& .body {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 0.5rem;

		& input[type="text"] {
			flex-grow: 1;

			&:last-of-type {
				width: 150px;
			}
		}

		& input[type="checkbox"] {
			width: 20px;
		}

		& label {
			padding: 0.5rem 0;
		}
	}
`;
